export default "__VITE_PUBLIC_ASSET__6ad47274__"